import {EmbedContext} from 'components/EmbedContext'
import {useAppSelector} from 'hooks'
import {useContext} from 'react'
import {useTranslation} from 'react-i18next'

export const useTimeFormat = () => {
    const {i18n} = useTranslation()
    const embed = useContext(EmbedContext)
    const forcedTimeFormat = embed?.timeFormat
    const hour = forcedTimeFormat || useAppSelector(({ninchat}) => ninchat.user_settings.time_format_hour || undefined)

    const forcedTimeLocale = embed?.timeLocale
    const currentLocale = forcedTimeLocale || i18n.language

    return [hour, currentLocale]
}
